import React, { useState } from "react";
import { GridLegacy } from "@mui/material";
import FormTextTC from "../../components/Forms/FormTextTC";
import FormV2 from "../JamezzForm/FormV2";
import MainNavbar from "../../components/Navbars/MainNavbar";
import { withStyles } from "tss-react/mui";
import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import AuthProvider from "../../auth/AuthProvider";
import ImageUuids from "../Producten/ImageUuids";
import FormSwitchTC from "../../components/Forms/FormSwitchTC";

const endPoint = "core/articleTraits";

function ArticleTraitForm(props) {
  const [articleTrait, setArticleTrait] = useState(null);

  return (
    <AuthProvider prefix={"articleTraits"}>
      <MainNavbar paginaTitel={"Article Traits"} subject={articleTrait?.name} />
      <GridLegacy container spacing={1}>
        <GridLegacy item xs={12}>
          <FormV2
            endPoint={endPoint}
            mode={"onSubmit"}
            onGetModel={(profile) => {
              setArticleTrait(profile);
            }}
            parseInput={{
              img_uuids: (response) => {
                return response
                  ? JSON.parse(response).map((uuid) => ({
                      uuid: uuid,
                    }))
                  : [];
              },
            }}
            parseOutput={{
              img_uuids: (img_uuid) => img_uuid,
            }}
            revalidateMode={"onChange"}
          >
            <GridLegacy container spacing={1}>
              <FormTextTC disabled={true} name={"name"} tDefault={"Name"} tKey={"articleTrait.name"} />
              <FormSwitchTC
                name={"is_active_in_jamezz"}
                tDefault={"Enabled"}
                tKey={"articleTraits.is_active_in_jamezz"}
              />
              <FormSwitchTC
                name={"use_as_quick_filter"}
                tDefault={"Use as quick filter"}
                tKey={"articleTraits.use_as_quick_filter"}
              />
            </GridLegacy>

            {articleTrait ? <ImageUuids /> : null}
          </FormV2>
        </GridLegacy>
      </GridLegacy>
    </AuthProvider>
  );
}

export default withStyles(ArticleTraitForm, vestigingStyle);
